// extracted by mini-css-extract-plugin
export default {"wrapper":"EmptyPageSection_wrapper__oZW73","content":"EmptyPageSection_content__5ezXZ","caption":"EmptyPageSection_caption__+pJwl"};